import { Box } from "@mui/material";
import { useThemeContext } from "../globalContext/global-context";
import type { RawVisualGrouping } from "./visualGroups";

export const VisualGroupHeading = ({ text }: { text?: string }) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  if (text === undefined) return null;
  return (
    <Box
      component="h3"
      data-visual-group-heading
      sx={{
        gridColumn: "1 / -1",
        width: "100%",
        m: 0,
        paddingBlock: `${theme.tokens.spacing["2"]}px`,
        color: theme.tokens.color.text.primary,
        fontSize: theme.tokens.typography.size.md,
        fontWeight: theme.tokens.typography.weight.bold,
        textAlign: "start",
        overflowWrap: "anywhere",
      }}
    >
      {text}
    </Box>
  );
};

export const VisualGroupContext = ({
  question,
  parentGroup,
}: {
  question: RawVisualGrouping & { rows?: unknown; columns?: unknown };
  parentGroup?: string;
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const groups = [
    { axis: question.rows, groups: question.row_groups },
    { axis: question.columns, groups: question.column_groups },
  ].flatMap(({ axis, groups }) => (axis === undefined ? (groups ?? []) : []));
  const labels = groups.map((group) => group.text);
  if (parentGroup !== undefined) labels.unshift(parentGroup);
  return labels.length > 0 ? (
    <Box
      component="p"
      data-testid="visual-group-context"
      sx={{
        margin: 0,
        paddingBlock: `${theme.tokens.spacing["2"]}px`,
        color: theme.tokens.color.text.secondary,
        fontSize: theme.tokens.typography.size.sm,
        textAlign: "start",
      }}
    >
      {labels.join(" · ")}
    </Box>
  ) : null;
};
